import { Navbar } from "./../navbar";

import * as S from "./styles";

export const PageLayout = ({ children, wrapperStyle }) => {
  return (
    <S.Container>
      <Navbar />
      <S.Wrapper style={wrapperStyle}>{children}</S.Wrapper>
      <footer>
        <small>shaktis &copy; 2025</small>
      </footer>
    </S.Container>
  );
};
